module.exports = __webpack_public_path__ + "static/media/logo.62be6fde.jpg";